export default __webpack_public_path__ + "static/media/reservaClosed.b484b73e.jpg";